import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import WhatsAppWidget from "./components/WhatsApp/WhatsAppWidget";
import CustomerDashboard from "./components/Customer/CustomerDashboard";
import CustomerProfile from "./components/Customer/CustomerProfile";
import CustomerPurchaseList from "./components/Customer/CustomerPurchaseList";
import FreeStringingServices from "./components/Customer/FreeStringingServices";
import NotificationList from "./components/NotificationList";
import CreateTicket from "./components/Customer/CreateTicket";
import CustomerTransactions from "./components/Customer/CustomerTransactions";
import CustomerBookingList from "./components/Customer/CustomerBookingList";
import CustomerBookingForm from "./components/Customer/Booking/CustomerBookingForm";
import CustomerBookingFinal from "./components/Customer/Booking/CustomerBookingFinal";
import CustomerPaymentSuccess from "./pages/CustomerPaymentSuccess";
import GripPaymentSuccess from "./pages/GripPaymentSuccess";
import BookingSuccess from "./pages/BookingSuccess";
import CustomerWaiting from "./pages/CustomerWaiting";
import Footer from "./components/Footer/Footer";
import AutoLogin from "./BigCommerce/AutoLogin";
import EditInfo from "./components/Customer/CustomerEdit/EditInfo/EditInfo";
import EditAddress from "./components/Customer/CustomerEdit/EditAddress/EditAddress";
import GripBookingForm from "./components/Customer/Grip/GripBooking/GripBookingForm";
import GripBookingDetails from "./components/Customer/Grip/GripBooking/GripBookingDetails";
import GripBookingFinal from "./components/Customer/Grip/GripBooking/GripBookingFinal";
import RestringingRouter from "./routes/RestringingRouter";
import WhatsappBookingForm from "./components/WhatsApp/WhatsappBookingForm";
import WhatsappSuccess from "./components/WhatsApp/WhatsappSuccess";


const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const App = () => {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
      <Router basename="/">
        <div>
          <Routes>
            <Route path="/" element={<Navigate to="/customer/dashboard" replace />} />
            <Route path="/stringing/*" element={<Navigate to="/customer/dashboard" replace />} />
            <Route path="/autologin" element={<AutoLogin />} />
            <Route path="/customer/dashboard" element={<CustomerDashboard />}>
              <Route index element={<CustomerPurchaseList />} />
              <Route path="profile" element={<CustomerProfile />} />
              <Route path="purchases" element={<CustomerPurchaseList />} />
              <Route path="restringing" element={<RestringingRouter />} />
              <Route
                path="stringing-services"
                element={<FreeStringingServices />}
              />
              <Route path="grip-services" element={<GripBookingForm />} />
              <Route path="create-ticket" element={<CreateTicket />} />
              <Route path="booking-list" element={<CustomerBookingList />} />
              <Route path="booking-form" element={<CustomerBookingForm />} />
              <Route path="booking-final" element={<CustomerBookingFinal />} />
              <Route
                path="grip-booking-details"
                element={<GripBookingDetails />}
              />
              <Route path="grip-booking-final" element={<GripBookingFinal />} />
              <Route
                path="your-transactions"
                element={<CustomerTransactions />}
              />
              <Route path="edit-info" element={<EditInfo />} />
              <Route path="edit-address" element={<EditAddress />} />
            </Route>
            <Route path="/notifications" element={<NotificationList />} />
            <Route
              path="/customer-payment-success"
              element={<CustomerPaymentSuccess />}
            />
            <Route
              path="/grip-payment-success"
              element={<GripPaymentSuccess />}
            />

            <Route path="/booking-success" element={<BookingSuccess />} />
            <Route
              path="/customer-waiting-for-payment"
              element={<CustomerWaiting />}
            />
            <Route path="/whatsapp-booking" element={<WhatsappBookingForm />} />
            <Route path="/whatsapp-success" element={<WhatsappSuccess />} />
          </Routes>

          <WhatsAppWidget />
          <Footer />
        </div>
      </Router>
    </GoogleReCaptchaProvider>
  );
};

export default App;
